import {useState, useContext} from "react";
import {useIntl} from "react-intl";
import {message} from "antd";
import {ASSET_TYPE} from "components/Layout/constants";
import useHandleAssetInfo from "./useHandleAssetInfo";
import useUploadAsset from "./useUploadAsset";

function useDragAndDropAsset(updateUploadProgress, updateUploadingAssetInfo) {
  const [isMyAssetDroppable, setIsMyAssetDroppable] = useState(false);
  const {checkFileType} = useHandleAssetInfo();
  const {createAsset} = useUploadAsset(updateUploadProgress, updateUploadingAssetInfo);
  const intl = useIntl();

  const handleDropMyAsset = (e, setCurrentType) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    for (let i = 0; i < files.length; i++) {
      const {assetType} = checkFileType(files[i].name);
      if (assetType === ASSET_TYPE.NOT_SUPPORTED) {
        message.warn({
          content: intl.formatMessage({id: "ID_ASSET_NOT_SUPPORTED"}),
          duration: 1,
        });
      } else {
        createAsset(files[i], setCurrentType);
      }
    }
    setIsMyAssetDroppable(false);
  };

  const handleDragOverMyAsset = e => {
    e.preventDefault();
  };

  const handleDragEnterMyAsset = e => {
    e.preventDefault();
    setIsMyAssetDroppable(true);
  };

  const handleDragLeaveMyAsset = e => {
    e.preventDefault();
    setIsMyAssetDroppable(false);
  };

  const handleDragAssetStartToScene = (e, assetInfo) => {
    e.dataTransfer.setData("text/plain", JSON.stringify(assetInfo));
  };

  return {
    handleDropMyAsset,
    handleDragOverMyAsset,
    handleDragEnterMyAsset,
    handleDragLeaveMyAsset,
    isMyAssetDroppable,
    handleDragAssetStartToScene,
  };
}

export default useDragAndDropAsset;
